// Bake'em - expiry time defaults to 1 month
export function createCookie(name, value, minutes) {
  let date = new Date();
  date.setTime(date.getTime() + (minutes ? (parseInt(minutes, 10) * 60 * 1000) : (30 * 24 * 60 * 60 * 1000)));
  if (typeof document !== 'undefined') {
    document.cookie = (name + "=" + value + "; expires=" + date.toUTCString() + "; path=/");
  }
}

  // Check if they are edible  - Find a cookie and return its value as a string, or return null if cookie isn't found
export function getCookie(name) {
  let regexp = new RegExp(name + "=([^;]+)");
  let value = null;
  if (typeof document !== 'undefined') {
    value = regexp.exec(document.cookie);
  }
  return (value === null) ? null : value[1];
}

  // Eat'em - set the expiration date in the past
export function deleteCookie(name) {
  if (typeof document !== 'undefined') {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}

export function getEnrollCartProductIds() {
  let aEnrollCart = [null, null];
  if (getCookie('enrollCart')) {
    let tempEnrollCart = getCookie('enrollCart')
      .split(',');
    if(tempEnrollCart[0]){
      aEnrollCart[0] = {id: parseInt(tempEnrollCart[0]), quantity: 1, format: tempEnrollCart[1] };
    }
    if(tempEnrollCart[2]){
      aEnrollCart[1] = {id: parseInt(tempEnrollCart[2]), format: tempEnrollCart[3], quantity: 1 };
    }
  }
  return aEnrollCart;
}

export function createEnrollCartCookie(enrollCart) {
  let aEnrollCart = [];
  if( enrollCart[0] ){
    aEnrollCart.push(enrollCart[0].id); aEnrollCart.push(enrollCart[0].format);
  } else {
    aEnrollCart.push(null); aEnrollCart.push(null);
  }
  if( enrollCart[1] ){
    aEnrollCart.push(enrollCart[1].id); aEnrollCart.push(enrollCart[1].format);
  } else {
    aEnrollCart.push(null); aEnrollCart.push(null);
  }
  createCookie('enrollCart', aEnrollCart.join());
}


// WEBPACK FOOTER //
// ./src/shared/cookie.js